import * as React from 'react'

export const ArchiveIcon = React.forwardRef<
  SVGSVGElement,
  {
    color?: string
    width?: number
    height?: number
  } & React.SVGProps<SVGElement>
>(({ style, width = 15, height = 15, ...props }, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 15"
      fill="none"
      {...props}
      width={width}
      height={height}
      style={style}
      ref={ref}
    >
      <path
        fill="currentColor"
        d="m13.447 3.776-1-2A.5.5 0 0 0 12 1.5H3a.5.5 0 0 0-.447.276l-1 2A.505.505 0 0 0 1.5 4v8.5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4a.505.505 0 0 0-.053-.224ZM3.31 2.5h8.382l.5 1H2.81l.5-1Zm9.191 10h-10v-8h10v8ZM9.854 8.646a.5.5 0 0 1 0 .708l-2 2a.502.502 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7 9.793V6a.5.5 0 1 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708 0Z"
      />
    </svg>
  )
})
